var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2954 0.625C9.29847 0.625 8.36802 1.15964 7.86614 2.02027L6.49284 4.37502H4.0624C1.82239 4.37502 -0.00012207 6.19754 -0.00012207 8.43755V20.3126C-0.00012207 22.5526 1.82239 24.3752 4.0624 24.3752H20.9375C23.1775 24.3752 25 22.5526 25 20.3126V8.43755C25 6.19754 23.1775 4.37502 20.9375 4.37502H18.5071L17.1338 2.02027C16.6319 1.15964 15.7014 0.625 14.7046 0.625H10.2954ZM12.5 8.12505C15.6012 8.12505 18.125 10.6482 18.125 13.7501C18.125 16.852 15.6012 19.3751 12.5 19.3751C9.39869 19.3751 6.87492 16.852 6.87492 13.7501C6.87492 10.6482 9.39869 8.12505 12.5 8.12505V8.12505ZM12.5 10.0001C10.4289 10.0001 8.74994 11.679 8.74994 13.7501C8.74994 15.8212 10.4289 17.5001 12.5 17.5001C14.571 17.5001 16.25 15.8212 16.25 13.7501C16.25 11.679 14.571 10.0001 12.5 10.0001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.8b071bc7.svg";
export { ForwardRef as ReactComponent };